import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import FiboImage from "../../../assets/Models/images/FiboImage.png";
import FiboLiteImage from "../../../assets/Models/images/FiboLiteImage.jpg";
import AuxiliaryRMBG from "../../../assets/Models/images/auxiliary-remove_bg.png";
import FiboEditImage from "../../../assets/Models/images/fibo-edit.jpg";
import Github from "../../../assets/images/icons/Github";
import HuggingFace from "../../../assets/images/icons/HuggingFace";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../components/common/BriaButtonGroup/BriaButtonGroup";
import BriaLogo from "../../../components/common/BriaLogo/BriaLogo";
import { FEATURE_FLAGS } from "../../../constants/FeatureFlags.ts";
import LinkConstants from "../../../constants/LinkConstants";
import { useLdFeatureFlag } from "../../../hooks/useLdFeatureFlag.ts";
import styles from "./ModelsOverview.module.scss";

const ModelsOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "models" });
	const openDocs = (link: string) => window.open(link, "_blank");
	const isFiboLiteEnabled = useLdFeatureFlag(FEATURE_FLAGS.FIBO_LITE_FEATURE);

	// Foundation Models
	const foundationModelsCards: ConsoleAPICardProps[] = [
		{
			image: FiboEditImage,
			header: t("foundation.cards.fiboEdit.header"),
			description: t("foundation.cards.fiboEdit.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["FIBO_EDIT"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace />}
					>
						{t("foundation.cards.fiboEdit.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.BRIA_FIBO_EDIT_SANDBOX, "_blank")}
						startIcon={<BriaLogo className={styles.logo} />}
					>
						{t("foundation.cards.fiboEdit.secondaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.MODELS.FOUNDATION["FIBO_EDIT"].GITHUB, "_blank")}
						startIcon={<Github />}
					>
						{t("foundation.cards.fiboEdit.gitHub")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: FiboImage,
			header: t("foundation.cards.fibo.header"),
			description: t("foundation.cards.fibo.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["FIBO"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace />}
					>
						{t("foundation.cards.fibo.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.BRIA_FIBO_SANDBOX, "_blank")}
						startIcon={<BriaLogo className={styles.logo} />}
					>
						{t("foundation.cards.fibo.secondaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => window.open(LinkConstants.MODELS.FOUNDATION["FIBO"].GITHUB, "_blank")}
						startIcon={<Github />}
					>
						{t("foundation.cards.fibo.gitHub")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		...(isFiboLiteEnabled
			? [
					{
						image: FiboLiteImage,
						header: t("foundation.cards.fiboLite.header"),
						description: t("foundation.cards.fiboLite.description"),
						buttons: (
							<BriaButtonGroup>
								<BriaButton
									buttonType="textSmall"
									onClick={() =>
										openDocs(LinkConstants.MODELS.FOUNDATION["FIBO_LITE"].HUGGING_FACE.MODEL)
									}
									startIcon={<HuggingFace />}
								>
									{t("foundation.cards.fiboLite.primaryBtn")}
								</BriaButton>
								<BriaButton
									buttonType="textSmall"
									onClick={() => window.open(LinkConstants.BRIA_FIBO_LITE_SANDBOX, "_blank")}
									startIcon={<BriaLogo className={styles.logo} />}
								>
									{t("foundation.cards.fiboLite.secondaryBtn")}
								</BriaButton>
								<BriaButton
									buttonType="textSmall"
									onClick={() =>
										window.open(LinkConstants.MODELS.FOUNDATION["FIBO_LITE"].GITHUB, "_blank")
									}
									startIcon={<Github />}
								>
									{t("foundation.cards.fiboLite.gitHub")}
								</BriaButton>
							</BriaButtonGroup>
						),
					},
				]
			: []),
		// {
		// 	image: Foundation3_2,
		// 	header: t("foundation.cards.3_2.header"),
		// 	description: t("foundation.cards.3_2.description"),
		// 	buttons: (
		// 		<BriaButtonGroup>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_2"].HUGGING_FACE.MODEL)}
		// 				startIcon={<HuggingFace />}
		// 			>
		// 				{t("foundation.cards.3_2.primaryBtn")}
		// 			</BriaButton>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_2"].HUGGING_FACE.DEMO)}
		// 				startIcon={<HuggingFace />}
		// 			>
		// 				{t("foundation.cards.3_2.secondaryBtn")}
		// 			</BriaButton>
		// 		</BriaButtonGroup>
		// 	),
		// },
		// {
		// 	image: Foundation3_1,
		// 	header: t("foundation.cards.3_1.header"),
		// 	description: t("foundation.cards.3_1.description"),
		// 	buttons: (
		// 		<BriaButtonGroup>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_1"].HUGGING_FACE.MODEL)}
		// 				startIcon={<HuggingFace />}
		// 			>
		// 				{t("foundation.cards.3_1.primaryBtn")}
		// 			</BriaButton>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_1"].HUGGING_FACE.DEMO)}
		// 				startIcon={<HuggingFace />}
		// 			>
		// 				{t("foundation.cards.3_1.secondaryBtn")}
		// 			</BriaButton>
		// 		</BriaButtonGroup>
		// 	),
		// },
		// {
		// 	image: Foundation4B_Adapt,
		// 	header: t("foundation.cards.4b_adapt.header"),
		// 	description: t("foundation.cards.4b_adapt.description"),
		// 	buttons: (
		// 		<BriaButtonGroup>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["4B_ADAPT"].HUGGING_FACE.MODEL)}
		// 				startIcon={<HuggingFace />}
		// 			>
		// 				{t("foundation.cards.4b_adapt.primaryBtn")}
		// 			</BriaButton>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["4B_ADAPT"].HUGGING_FACE.DEMO)}
		// 				startIcon={<HuggingFace />}
		// 			>
		// 				{t("foundation.cards.4b_adapt.secondaryBtn")}
		// 			</BriaButton>
		// 		</BriaButtonGroup>
		// 	),
		// },
	];

	// Auxiliary Models
	const auxiliaryModelsCards: ConsoleAPICardProps[] = [
		// {
		// 	image: Auxiliary4BAdaptUnion,
		// 	header: t("auxiliary.cards.bria3_2_union.header"),
		// 	description: t("auxiliary.cards.bria3_2_union.description"),
		// 	buttons: (
		// 		<BriaButtonGroup>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				startIcon={<HuggingFace />}
		// 				onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_2_UNION"].HUGGING_FACE.MODEL)}
		// 			>
		// 				{t("auxiliary.cards.bria3_2_union.primaryBtn")}
		// 			</BriaButton>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				startIcon={<HuggingFace />}
		// 				onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_2_UNION"].HUGGING_FACE.DEMO)}
		// 			>
		// 				{t("auxiliary.cards.bria3_2_union.secondaryBtn")}
		// 			</BriaButton>
		// 		</BriaButtonGroup>
		// 	),
		// },
		// {
		// 	image: Auxiliary4BAdaptUnion,
		// 	header: t("auxiliary.cards.bria3_1_union.header"),
		// 	description: t("auxiliary.cards.bria3_1_union.description"),
		// 	buttons: (
		// 		<BriaButtonGroup>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				startIcon={<HuggingFace />}
		// 				onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_1_UNION"].HUGGING_FACE.MODEL)}
		// 			>
		// 				{t("auxiliary.cards.bria3_1_union.primaryBtn")}
		// 			</BriaButton>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				startIcon={<HuggingFace />}
		// 				onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_1_UNION"].HUGGING_FACE.DEMO)}
		// 			>
		// 				{t("auxiliary.cards.bria3_1_union.secondaryBtn")}
		// 			</BriaButton>
		// 		</BriaButtonGroup>
		// 	),
		// },
		// {
		// 	image: Auxiliary4BAdaptUnion,
		// 	header: t("auxiliary.cards.4b_adapt_union.header"),
		// 	description: t("auxiliary.cards.4b_adapt_union.description"),
		// 	buttons: (
		// 		<BriaButtonGroup>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				startIcon={<HuggingFace />}
		// 				onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["4B_UNION"].HUGGING_FACE.MODEL)}
		// 			>
		// 				{t("auxiliary.cards.4b_adapt_union.primaryBtn")}
		// 			</BriaButton>
		// 			<BriaButton
		// 				buttonType="textSmall"
		// 				startIcon={<HuggingFace />}
		// 				onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["4B_UNION"].HUGGING_FACE.DEMO)}
		// 			>
		// 				{t("auxiliary.cards.4b_adapt_union.secondaryBtn")}
		// 			</BriaButton>
		// 		</BriaButtonGroup>
		// 	),
		// },
		{
			image: AuxiliaryRMBG,
			header: t("auxiliary.cards.rmgb_2_0.header"),
			description: t("auxiliary.cards.rmgb_2_0.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["REMOVE_BG"].HUGGING_FACE.MODEL)}
					>
						{t("auxiliary.cards.rmgb_2_0.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => window.open(LinkConstants.BRIA_REMOVE_BG_SANDBOX, "_blank")}
					>
						{t("auxiliary.cards.rmgb_2_0.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
	];

	return (
		<Box className={styles.layout}>
			<Box className={styles.overview}>
				<ConsoleAPILayout
					description={t("foundation.description")}
					hideCopyTokenBtn
					descriptionClassName={styles.description}
				>
					<div className={styles.section}>
						<h2 className={styles.sectionTitle}>{t("foundation.tab")}</h2>
						<ConsoleAPICards cards={foundationModelsCards} className={styles.cards} />
					</div>
					<div className={styles.section}>
						<h2 className={styles.sectionTitle}>{t("auxiliary.tab")}</h2>
						<ConsoleAPICards cards={auxiliaryModelsCards} className={styles.cards} />
					</div>
				</ConsoleAPILayout>
			</Box>
			{/* <OverviewIntegrations
				className={styles.integrations}
				cards={["HUGGING_FACE", "GITHUB", "FAL", "REPLICATE", "INVOKE", "AWS", "AZURE", "DISCORD"]}
				pageName="models-overview"
			/> */}
		</Box>
	);
};

export default observer(ModelsOverview);
